"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StateDashboard = void 0;
const gs = require("@ivanlog/gs");
const com = require("../../plusx-lib/com/tmpls");
const StatePaged_1 = require("../../plusx-lib/states/abstracts/StatePaged");
const App_1 = require("../../plusx-lib/App");
class StateDashboard extends StatePaged_1.StatePaged {
    constructor() {
        super(com.PageVX, "ValidatorX DApp", true);
        this.page.ctrls.cmpHeroVX.ctrls.blockTags.show();
        this.page.ctrls.widgetVXApp.setStatusCmp(this.page.ctrls.widgetVXStatus);
        this.page.ctrls.widgetInfoVXS.ctrls.aMain.el.href = '/?state=dashboard&vxs=1';
        this.page.ctrls.widgetInfoVX.ctrls.aMain.el.href = '/';
        this.page.ctrls.widgetVXSApp.ctrls.btnTabVX.onclick = () => this._openVX();
        this._refreshHandler = () => __awaiter(this, void 0, void 0, function* () {
            yield this._refreshAsync();
        });
    }
    start() {
        const _super = Object.create(null, {
            start: { get: () => super.start }
        });
        return __awaiter(this, void 0, void 0, function* () {
            this.gui.showPage(this.page);
            this._refreshAsync();
            return _super.start.call(this);
        });
    }
    afterStart() {
        const _super = Object.create(null, {
            afterStart: { get: () => super.afterStart }
        });
        return __awaiter(this, void 0, void 0, function* () {
            App_1.App.chain.onChangeAccount.addHandler(this._refreshHandler);
            this.page.ctrls.widgetInfoVXS.ctrls.aMain.onclick = (e) => {
                gs.events.stop(e);
                this._openVXS();
            };
            this.page.ctrls.widgetInfoVX.ctrls.aMain.onclick = (e) => {
                gs.events.stop(e);
                this._openVX();
            };
            yield _super.afterStart.call(this);
        });
    }
    stop() {
        const _super = Object.create(null, {
            stop: { get: () => super.stop }
        });
        return __awaiter(this, void 0, void 0, function* () {
            App_1.App.chain.onChangeAccount.removeHandler(this._refreshHandler);
            yield _super.stop.call(this);
        });
    }
    _openVX() {
        return __awaiter(this, void 0, void 0, function* () {
            this.page.ctrls.widgetInfoVXS.show();
            this.page.ctrls.widgetInfoVX.hide();
            this.page.ctrls.widgetVXApp.show();
            this.page.ctrls.widgetVXSApp.hide();
        });
    }
    _openVXS() {
        return __awaiter(this, void 0, void 0, function* () {
            this.page.ctrls.widgetInfoVXS.hide();
            this.page.ctrls.widgetInfoVX.show();
            this.page.ctrls.widgetVXApp.hide();
            this.page.ctrls.widgetVXSApp.show();
            this.page.ctrls.widgetVXSApp.loadAsync();
        });
    }
    _refreshAsync() {
        return __awaiter(this, void 0, void 0, function* () {
            const ctrls = this.page.ctrls;
            yield ctrls.widgetVXApp.refreshAsync();
            yield ctrls.cmpHeroVX.showAPR(ctrls.widgetVXApp.vxAPR);
        });
    }
}
exports.StateDashboard = StateDashboard;
StateDashboard.StateName = "dashboard";
//# sourceMappingURL=StateDashboard.js.map